<button mat-mini-fab color="accent" (click)="backToTop()">
    <mat-icon svgIcon="arrow-upward"></mat-icon>
</button>